<!-- Client logo -->
<div class="cl-logo section-pad">
	<div class="container">
		<div class="row">
			<div class="owl-carousel loop logo-carousel">
				<div *ngFor="let partner of partners" class="col-md-2 ">
					<img alt="{{partner.name}}" width="190" height="82" src="{{urlHost}}{{partner.imagePath}}">
				</div>
				<!-- <div>
					<img alt="" width="190" height="82" src="assets/App_Themes/image/cl-logo2.png">
				</div>
				<div>
					<img alt="" width="190" height="82" src="assets/App_Themes/image/cl-logo3.png">
				</div>
				<div>
					<img alt="" width="190" height="82" src="assets/App_Themes/image/cl-logo4.png">
				</div>
				<div>
					<img alt="" width="190" height="82" src="assets/App_Themes/image/cl-logo5.png">
				</div>
				<div>
					<img alt="" width="190" height="82" src="assets/App_Themes/image/cl-logo6.png">
				</div> -->
			</div>
		</div>
	</div>
</div>
<!-- footer widget-->
<div class="footer-widget section-pad">
	<div class="container">
		<div class="row">
			<div class="widget-container row">
				<div class="footer-col about-us col-md-3 col-sm-6 res-m-bttm">
					<h5 class="heading-col">Về chúng tôi</h5>
					<div class="bottom-des">
						<div class="about-des">
							<!-- <p>{{introduce.name}}</p> -->
							<p innerHtml="{{introduce.subTitle}}"></p>
							<a href="/gioi-thieu">Xem thêm...</a>
						</div>
						<!-- <div class="subscribe">
								<form id="subscribe-me" action="http://demo.themenio.com/tranship/form/subscribe.php"
									method="post">
									<input name="EMAIL" class="form-control required email" type="email"
										placeholder="Email for Newsletter">
									<input type="text" class="hidden" name="form-anti-honeypot" value="">
									<input type="submit" name="submit" value="Signup" class="submit">
									<div class="form-results"></div>
								</form>
							</div> -->
					</div>
				</div>
				<div class="footer-col navigation col-md-2 col-md-offset-1 col-sm-6 res-m-bttm">
					<h5 class="heading-col">Liên kết nhanh</h5>
					<ul class="bottom-des">
						<li *ngFor="let item of menus">
							<a [routerLink]="item.code">{{item.name}}</a>
						</li>
					</ul>
				</div>
				<div class="footer-col service-col col-md-3 col-sm-6 res-m-bttm">
					<h5 class="heading-col">Dịch vụ</h5>
					<ul class="bottom-des">
						<li *ngFor="let item of services">
							<a routerLink="/dich-vu/{{item.id}}/{{item.code}}">{{item.name}}</a>
						</li>
					</ul>
				</div>
				<div class="footer-col contact col-md-3 col-sm-6">
					<h5 class="heading-col">Liên hệ</h5>
					<ul class="bottom-des contact-des">
						<li>
							<i class="fa fa-map" aria-hidden="true"></i>
							<span>{{generalInfo.address}}</span>
						</li>
						<li>
							<i class="fa fa-phone" aria-hidden="true"></i>
							<span>Hotline : {{generalInfo.hotline}}<br>
								Điện thoại : {{generalInfo.companyPhone}}</span>
						</li>
						<li>
							<i class="fa fa-envelope" aria-hidden="true"></i>
							<span>Email : <a href="#">{{generalInfo.email}}</a>
								<!-- <br>
								Web : <a href="#">www.truongthinhphat.com</a> -->
							</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- End footer widget -->

<!-- Copyright -->
<div class="copyright">
	<div class="container">
		<div class="row">
			<span>Bản quyền <i class="fa fa-copyright" aria-hidden="true"></i>
				2021 VẬN TẢI TRƯỜNG THỊNH PHÁT. Đã đăng ký bản quyền. Thiết kế bởi: <a style="color: yellow;"
					href="http://ssw.vn/" title="SOLUTIONS WORLD" target="_blank">SSW.VN</a></span>
			<ul class="social">
				<li *ngFor="let item of socials">
					<a href="{{item.path}}"><i class="fa {{getSocial(item.code)}}" aria-hidden="true"></i></a>
				</li>
			</ul>
		</div>
	</div>
</div>
<!-- End copyright -->

<!-- preload slider image for carousel -->
<!-- <div class="preload hide">
	<img alt="" src="assets/App_Themes/image/banner.jpg">
	<img alt="" src="assets/App_Themes/image/banner-2.jpg">
	<img alt="" src="assets/App_Themes/image/banner-3.jpg">
</div> -->
<!-- End -->
<!-- Preloader -->
<!-- <div id="preloader">
		<div id="status">&nbsp;</div>
	</div> -->
<!-- End Preloader -->